import gql from 'graphql-tag'

export const GET_SECTIONS = gql`
  query getSections($where: GetSectionBasedOnPlanInput) {
    getSections(where: $where) {
      id
      section
      index
      questions {
        id
        question
        index
        type
        isRequired
        point
        includeInvestmentValidation
        options {
          id
          option
          point
          isDefault
          value
          multiplication
        }
      }
    }
  }
`

export const GET_KYC = gql`
  query kyc($userId: Int) {
    kyc(where: { userId: $userId }) {
      id
      kycForm
      agreementData
      agreementForNonIndividual
      panCard
      aadharCard
      passportSize
      signature
      cancelledChequeSnap
      bankStatement
      aadharCardBack
      incomeProof
    }
  }
`
export const GET_SP_AUTO_ADVISE = gql`
  query spAutoAdvise($where: spAutoAdviseInput) {
    spAutoAdvise(where: $where)
  }
`
export const GET_SP_AGREEMENT_DATA = gql`
  query spAgreementData($where: spAgreementInput) {
    spAgreementData(where: $where)
  }
`

export const GET_PORTFOLIO_BETA = gql`
  query getPortfolioBeta($where: GetPortfolioBetaInput) {
    getPortfolioBeta(where: $where)
  }
`

export const GET_USER_ANSWERS = gql`
  query getUserAnswers($where: WherePlanInput) {
    getUserAnswers(where: $where) {
      id
      user {
        id
      }
      question {
        id
        type
      }
      selectedOptions
    }
  }
`

export const GET_ALL_USERS_ANSWERS = gql`
  query getAllUsersAnswers($where: AnswerUniqueInput) {
    getAllUsersAnswers(where: $where) {
      id
      user {
        id
      }
      question {
        id
        type
        question
      }
      selectedOptions
    }
  }
`

export const GET_MANDATE = gql`
  query getMandate($where: MandateWhereUniqueInput!) {
    getMandate(where: $where) {
      id
      user {
        id
        bank
        accountType
        accountNumber
        email
        phone
        firstName
        lastName
        mandateId
      }
      ifscCode
      mandateStatus
      bankStatus
      createdAt
    }
  }
`
export const PARTNERS_DETAILS = gql`
  query partnerDetails($where: PartnerDetailsWhereUniqueInput!) {
    partnerDetails(where: $where) {
      id
      pan
      name
      uidOrDin
      address
      relationshipWithApplicant
      politicallyExposed
      user {
        id
      }
      createdAt
      updatedAt
    }
  }
`

export const GET_CLIENT_PROFILE2_PDF_LINK = gql`
  query getClientProfile2PdfLink {
    getClientProfile2PdfLink
  }
`

export const GET_CLIENT_PROFILE1_PDF_LINK = gql`
  query getClientProfile1PdfLink {
    getClientProfile1PdfLink
  }
`

export const NON_INDIVIDUAL_AGREEMENT_MAIL_SEND = gql`
  query nonIndividualAgreementMailSend {
    nonIndividualAgreementMailSend
  }
`

export const GET_ALL_FAQUESTION = gql`
  query GetAllFAQuestions {
    getAllFAQuestions {
      answer
      id
      question
      createdAt
      updatedAt
    }
  }
`

export const GET_BOOKING_ADVISORY = gql`
  query GetBookAdvisory($where: BookAdvisoryWhereInput) {
    getBookAdvisory(where: $where) {
      id
      userId
      advisoryDate
      isAdvisoryBooked
      isClientLogin
      isClientAcceptAdvisory
      advisorySendDateAndTime
      createdAt
      updatedAt
      advisoryAcceptDateAndTime
      isTermAndServiceAccepted
      advisorySendType
      isCancelAdvisory
      amcAmount
      paymentType
      advisoryType
      isPendingAdvisoryAccepted
      clientId {
        firstName
        lastName
        id
        clientCode
        email
        eMandateAmcAmount
      }
      advisorySubmittedUser {
        firstName
        lastName
        role
        email
        id
      }
      advisoryCancelByUser {
        firstName
        lastName
        role
        email
        id
      }
      advisoryUpdateByUser {
        firstName
        lastName
        role
        email
        id
      }
    }
  }
`

export const GET_PENDING_BOOKED_ADVISORY = gql`
query Query($where: GetPendingBookingAdvisoryInput, $data: AdvisorySourceInput) {
  getPendingBookingAdvisory(where: $where, data: $data)
  }
`

export const GET_NEW_PENDING_ADVISORY = gql`
query Query($where: AdvisoryDataReport, $data: AdvisorySourceInput) {
  getNewBookingAdvisory(where: $where, data: $data)
}
`
export const GET_RISK_PROFILE_SUMMARY = gql`
  query Query {
    getRiskProfileSummaryUi
  }
`

export const GET_USER_ADDONS = gql`
  query getUserAddons {
    getUserAddons {
      id
      userId
      parentId
      isCompleted
    }
  }
`

export const GET_USER_ADDONS_BY_ID = gql`
  query getUserAddonsById($id: ID!) {
    getUserAddonsById(id: $id) {
      id
      userId
      parentId
      isCompleted
    }
  }
`

export const GET_USERS_BY_PAN_CARD = gql`
  query getUsersByPanCard($where: UserCreateWhereInput) {
    getUsers(where: $where) {
      users {
        id
        exposure
        initialExposure
        plan {
          id
        }
        panCardNo
      }
      count
    }
  }
`
